import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { TasksVO, Task, ServerConstantsService, DataService, REPSTDT_GT_REPENDDT, REPSTDT_INTERVAL_REPENDDT, DateUtility, ComponentCount, AssessmentDataVO } from '../shared';
import { MIN_CHAR_SEARCH_LENGTH } from '../shared';
import { Appointment } from '../shared/model/appointment.model';
import { WpEtEnrollment } from '../shared/model/wp-et-enrollment.model';
import { WpMessages } from '../shared/model/WpMessages';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { APP_STORAGE_USERNAME, APP_STORAGE_FIRSTNAME, APP_STORAGE_REMEMBERME } from '../shared';
import { Subscription } from 'rxjs/Subscription';
import * as jsPDF from 'jspdf';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { CommonUtility } from '../shared/';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-federal-reports',
  templateUrl: './federal-reports.component.html',
  styleUrls: ['./federal-reports.component.scss']
})
export class FederalReportsComponent implements OnInit {
  title = 'app';
  tasksVO: TasksVO;
  tasks: Task[];
  appointments: Appointment[];
  enrollments: WpEtEnrollment[];
  currentTask: any;
  countyArray: string[] = [];
  areaCode: any;
  roleId: number;
  pendingTasks: Task[];
  openTasks: Task[];
  columnNameString: string[];
  someVal1: string;
  someVal2: string;
  someVal3: string;
  area1 = ["Benton","Carroll","Boone","Marion","Baxter","Fayetteville","Washington 1","Washington 2","Newton","Searcy","Crawford","Franklin","Logan 1","Logan 2","Scott","Polk","Sebastian"].sort();
  area2 = ["Fulton","Izard","Randolph","Clay","Sharp","Lawrence","Greene","Jackson","Craighead","Mississippi 1","Mississippi 2","Poinsett","Cross","Crittenden","Independence"].sort();
  area3 = ["Johnson","Pope","Yell","Perry","Conway","Van Buren","Faulkner","Stone","Cleburne","White","Lonoke","Prairie","Woodruff"].sort();
  area4 = ["Sevier","Little River","Miller","Lafayette","Hempstead","Pike","Montgomery","Columbia","Nevada","Clark","Hot Spring","Garland","Saline 1","Saline 2","Dallas","Ouachita","Calhoun","Union"].sort();
  area5 = ["Grant","Jefferson 1","Jefferson 2","Cleveland","Bradley","Lincoln","Drew","Ashley","Arkansas A","Arkansas B","Desha","Chicot","Monroe 1","Monroe 2","Phillips","Lee"].sort();
  area6 = ["Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest", "Central Office"].sort();
  allArea = ["Benton", "Carroll", "Boone", "Marion", "Baxter", "Fayetteville", "Washington 1", "Washington 2", "Newton", "Searcy", "Crawford", "Franklin", "Logan 1", "Logan 2", "Scott", "Polk", "Sebastian", "Fulton", "Izard", "Randolph", "Clay", "Sharp", "Lawrence", "Greene", "Jackson", "Craighead", "Mississippi 1", "Mississippi 2", "Poinsett", "Cross", "Crittenden", "Independence",
    "Johnson", "Pope", "Yell", "Perry", "Conway", "Van Buren", "Faulkner", "Stone", "Cleburne", "White", "Lonoke", "Prairie", "Woodruff", "Sevier", "Little River", "Miller", "Lafayette", "Hempstead", "Pike", "Montgomery", "Columbia", "Nevada", "Clark", "Hot Spring", "Garland", "Saline 1", "Saline 2", "Dallas", "Ouachita", "Calhoun", "Union",
    "Grant", "Jefferson", "Cleveland", "Bradley", "Lincoln", "Drew", "Ashley", "Arkansas A", "Arkansas B", "Desha", "Chicot","Monroe 1","Monroe 2", "Phillips", "Lee", "Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest", "Central Office"].sort();
  area1CountyNum = ["8","5","48","4","82","83","56","74","18","25","44","45","73","62","75"];
  area2CountyNum = ["26","34","70","12","77","40","29","35","17","50","51","61","20","19","33"];
  area3CountyNum = ["38","63","86","58","16","81","24","79","13","84","46","64","85"];
  area4CountyNum = ["76","43","49","39","30","60","54","15","55","11","31","27","71","72","21","57","7","80"];
  area5CountyNum = ["28","36","37","14","6","42","23","3","1","2","22","10","52","53","59","41"];
  area6CountyNum = ["65","66","67","68","69","9"];



  noData: Boolean = false;
  datestring: string;
  suggestions: any = [];
  inProgressTasks: Task[];
  inputTasksVO: TasksVO;
  pdfFlag = 'all';
  taskDueDateFrom:any;
  butDisabled: boolean = false;
  countyDisabled: boolean = false;
  participationDisabled: boolean = false;
  providerDisabled: boolean = false;

  clientSearch: any;
  reportBeginDate: any;
  reportNameOutput: any;
  countyList: string[];
  countyFinalList: string[];
  providerStringList: string[];
  providerFinalList: string[];
  reportStartPeriod: any;
  taskTypeList: string[];
  endDatePeriod: any;
  beginDatePeriod: any;
  errorBeginDateField: any;
  errorEndDateField: any;
  reportEndDate: any;
  tasktype: any;
  clientSearchOutput: any;
  county: any;
  provider: any;
  taskSearch: TasksVO;
  overdueCount: any;
  inProgressCount: any;
  upcomingCount: any;
  sharedData: any;
  countyId: any;
  referralId: number;
  wpPersonId: number;
  username: any;
  componentCountList: ComponentCount[];
  assessmentDataVOList: AssessmentDataVO[];
  tomorrowAppointment: any;
  missedAppointment: any;
  allAppointment: any;
  wpEtEnrollmentNull: any;
  wpEtEnrollmentNotNull: any;
  pendingCo: any;
  providerOutput: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  countyOutput: any;
  report: any;
  messagesList: WpMessages[];
  allCount: any;
  reportNames: any[];
  displayReportName: string = "";
  userActionNotificationsMap: any;
  ServerConstants: any;
  exportTable:any =[];
  valArray: any[];
  p: number = 1;
  g: number = 1;
  ws: any;
  @ViewChild('all') all: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('allFirst') allFirst: ElementRef;
  @ViewChild('allFirst1') allFirst1: ElementRef;
  @ViewChild('contentLast') contentLast: ElementRef;
  @ViewChild('contentDupLast') contentDupLast: ElementRef;
  @ViewChild('allLast') allLast: ElementRef;
  @ViewChild('allLast1') allLast1: ElementRef;
  @ViewChild('contentFirst') contentFirst: ElementRef;
  @ViewChild('contentFirst1') contentFirst1: ElementRef;
  @ViewChild('alldup1') alldup1: ElementRef
  @ViewChild('reportName') reportName: ElementRef;
  @ViewChild('providerOutputElement') providerOutputElement: ElementRef;
  @ViewChild('countyOutputElement') countyOutputElement: ElementRef;
  @ViewChild('datestringElement') datestringElement: ElementRef;
  @ViewChild('providerInput') providerInput: ElementRef;
  @ViewChild('countyInput') countyInput: ElementRef;
  @ViewChild('clientSearchElement') clientSearchElement: ElementRef;
  @ViewChild('reportingPeriod') reportingPeriod: ElementRef;
  componentCountListColumnDefs: any;
  componentProgressColumnDefs: any;
  educationalGainsColumnDefs: any;
  educationalRowData: any = [];
  context: any;
  private gridOptions: GridOptions;
  gridApi: any;
  gridEducationalApi: any;
  loaderFocus: Boolean = false;
  loaderGenerateFocus: Boolean = false;
  firstTime: Boolean = true;
  selectedValue: any;
  reportSelected: any;

  reportProviders: any[];
  reportParticipationTypes: any[];
  reportProvider: any;
  reportParticipation: any;

  @ViewChild('headerText') headerText: ElementRef;

  downloadExcelKeydown(event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.downloadExcel(event);
    }
  }

  downloadPDFKeydown(event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.downloadnodePDF(event);
    }
  }

  //inserting code
  downloadnodePDF(value) {
    var width = 420;
    var height = 220;
    var temp = [420, 220];
    var doc = new jsPDF("p", "mm", "a1");
    var rows = [];
    if (value == 'Component Progress - Client Level') {
      var col = [ "Month","Met Plan ?"];
      var rowCountModNew = this.componentCountList;
      rowCountModNew.forEach(element => {
        console.log("element data is " + element);
        var row=[element.period,element.metPlanCd];
        rows.push(row);
      });
      doc.text(15, 10, 'Report : Component Progress - Client Level');
      doc.text(15, 20, 'Client Name : '+this.clientSearchOutput);
      doc.text(15, 30, 'Reporting Period : '+this.reportStartPeriod);
      doc.text(15, 40, this.datestring);
      doc.autoTable(col, rows, {margin: {top: 50}});
      doc.save('Component_Progress_Client_Level.pdf');
    }
    else if (value == 'Component Progress - Rollup') {
      var col = [ "Month","Yes", "No", "No-GC Granted", "No-GC Not Granted"];
      var rowCountModNew = this.componentCountList;
      rowCountModNew.forEach(element => {
        console.log("element data is " + element);
        var row=[element.period,element.yesCount,element.noCount,element.gnCount,element.ggCount];
        rows.push(row);
      });
      doc.text(15, 10, 'Report    : Component Progress - Rollup');
      doc.text(15, 20,'Provider  : '+this.providerOutput);
      doc.text(15, 30,'County    : '+this.countyOutput);
      doc.text(15, 40, 'Reporting Period : '+this.reportStartPeriod);
      doc.text(15, 50, this.datestring);
      doc.autoTable(col, rows, {margin: {top: 60}});
      doc.save('Component_Progress_Rollup.pdf');
    }
    else if (value == 'Educational Gains - Rollup') {
      var col : string[] = [];
      var columnIteration = this.columnNameString;
      columnIteration.forEach(element => {
        col.push(element);
      });
      var rowCountModSome = this.assessmentDataVOList;
      rowCountModSome.forEach(element => {
        var row=[];
        var rowCountInsideElement = element.assesmentData;
        rowCountInsideElement.forEach(element => {
          row.push(element);
        });
        rows.push(row);
      });
      doc.text(15, 10, 'Report    : Educational Gains - Rollup');
      doc.text(15, 20,'Provider  : '+this.providerOutput);
      doc.text(15, 30,'County    : '+this.countyOutput);
      doc.text(15, 40, 'Reporting Period : '+this.reportStartPeriod);
      doc.text(15, 50, this.datestring);
      doc.autoTable(col, rows, {margin: {top: 60}});
      doc.save('Educational_Gains_Rollup.pdf');
    }

  }

  onLoad(value) {
    if (value == 'CC') {
      this.selectedValue = 1;
      document.getElementById("areaInput").setAttribute("hidden","true");
      document.getElementById("clientName").removeAttribute("hidden");
      document.getElementById("countyInput").setAttribute("hidden", "true");
      document.getElementById("providerInput").setAttribute("hidden", "true");
      document.getElementById("countyFinalInput").setAttribute("hidden", "true");
      document.getElementById("providerFinalInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").setAttribute("hidden", "true");
    }
    if (value == 'CR') {
      this.selectedValue = 2;
      document.getElementById("areaInput").removeAttribute("hidden");
      document.getElementById("clientName").setAttribute("hidden", "true");
      document.getElementById("countyInput").removeAttribute("hidden");
      this.loadUserInformation();
      document.getElementById("providerInput").removeAttribute("hidden");
      document.getElementById("countyFinalInput").setAttribute("hidden", "true");
      document.getElementById("providerFinalInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").removeAttribute("hidden");
    }
    if (value == 'ER') {
      this.selectedValue = 3;
      document.getElementById("areaInput").removeAttribute("hidden");
      document.getElementById("clientName").setAttribute("hidden", "true");
      document.getElementById("countyFinalInput").removeAttribute("hidden");
      document.getElementById("providerFinalInput").removeAttribute("hidden");
      document.getElementById("countyInput").setAttribute("hidden", "true");
      document.getElementById("providerInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").setAttribute("hidden", "true");
    }

    this.sharedData = this.dataService.getSharedDataObject();

    if (this.sharedData.get("roles")[0].id == 5) {
     this.butDisabled = true;
     }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
     {
     this.butDisabled = true;
     this.countyDisabled =  true;
     }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
     this.provider ="";
     this.providerFinalList=[];
     for(let i=0; i<this.sharedData.get("userCounties").length; i++){
        this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
        this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
      }
    this.butDisabled = true;
        for(let i=0; i<this.countyArray.length; i++) {
        //use i instead of 0
          if(this.area1CountyNum.includes(this.countyArray[i].toString()))
          {
            this.areaCode="Area I";
            this.countyFinalList=this.area1;
          }
          else if(this.area2CountyNum.includes(this.countyArray[i].toString()))
          {
            this.areaCode="Area II";
            this.countyFinalList=this.area2;
          }
            else if(this.area3CountyNum.includes(this.countyArray[i].toString()))
          {
            this.areaCode="Area III";
            this.countyFinalList=this.area3;
          }
            else if(this.area4CountyNum.includes(this.countyArray[i].toString()))
          {
            this.areaCode="Area IV";
            this.countyFinalList=this.area4;
          }
            else if(this.area5CountyNum.includes(this.countyArray[i].toString()))
          {
            this.areaCode="Area V";
            this.countyFinalList=this.area5;
          }
            else if(this.area6CountyNum.includes(this.countyArray[i].toString()))
          {
              this.areaCode="Area VI";
              this.countyFinalList=this.area6;
          }

      }
     }


  }

  onChange(value) {
    if (value == '1: CC') {
      this.selectedValue = 1;
      document.getElementById("areaInput").setAttribute("hidden","true");
      document.getElementById("clientName").removeAttribute("hidden");
      document.getElementById("countyInput").setAttribute("hidden", "true");
      document.getElementById("providerInput").setAttribute("hidden", "true");
      document.getElementById("countyFinalInput").setAttribute("hidden", "true");
      document.getElementById("providerFinalInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").setAttribute("hidden", "true");
    }
    if (value == '2: CR') {
      this.selectedValue = 2;
      document.getElementById("areaInput").removeAttribute("hidden");
      document.getElementById("clientName").setAttribute("hidden", "true");
      document.getElementById("countyInput").removeAttribute("hidden");
      document.getElementById("providerInput").removeAttribute("hidden");
      document.getElementById("countyFinalInput").setAttribute("hidden", "true");
      document.getElementById("providerFinalInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").removeAttribute("hidden");
    }
    if (value == '3: ER') {
      this.selectedValue = 3;
      document.getElementById("areaInput").removeAttribute("hidden");
      document.getElementById("clientName").setAttribute("hidden", "true");
      document.getElementById("countyFinalInput").removeAttribute("hidden");
      document.getElementById("providerFinalInput").removeAttribute("hidden");
      document.getElementById("countyInput").setAttribute("hidden", "true");
      document.getElementById("providerInput").setAttribute("hidden", "true");
      document.getElementById("participationInput").setAttribute("hidden", "true");
    }

    if (value == '4: ET') {
      this.router.navigate(["/reports/employment-training-retention"]);
    }

    if(value == '5: SD') {
      this.router.navigate(["reports/monthly-snapshot-details"]);
    }

    if(value == '6: SR') {
      this.router.navigate(["reports/monthly-snapshot-rollup"]);
    }
    if(value == '7: CA') {
      this.router.navigate(["reports/component-activity"]);
    }

    if(value == '8: PC') {
      this.router.navigate(["reports/potential-candidates"]);
    }

    if(value == '9: AR') {
      this.router.navigate(["reports/aries-task"]);
    }

    if (this.sharedData.get("roles")[0].id == 5) {
      console.log("butDisabled");
     this.butDisabled = true;
     }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
     {
     this.butDisabled = true;
     this.countyDisabled =  true;
     }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
     this.provider ="";
     this.providerFinalList=[];
         for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.butDisabled = true;
        for(let i=0; i<this.countyArray.length; i++){
    console.log(this.countyArray[i]);//use i instead of 0
    if(this.area1CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area I";
    this.countyFinalList=this.area1;
    }
    else if(this.area2CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area II";
    this.countyFinalList=this.area2;
    }
    else if(this.area3CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area III";
    this.countyFinalList=this.area3;
    }
    else if(this.area4CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area IV";
    this.countyFinalList=this.area4;
    }
    else if(this.area5CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area V";
    this.countyFinalList=this.area5;
    }
    else if(this.area6CountyNum.includes(this.countyArray[i].toString()))
    {
    this.areaCode="Area VI";
    this.countyFinalList=this.area6;
    }

    }
     }
    //this.load();
  }
  downloadExcel(value) {
    if (value == 'Component Progress - Client Level') {
      let contentData = this.allFirst1.nativeElement;
      let reportContent = this.reportName.nativeElement;
      const ws_name = 'TaskSheet';
      const wb: WorkBook = { SheetNames: [], Sheets: {} };
      this.ws = utils.table_to_sheet(contentData);
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = this.ws;
      const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
      const buf = new ArrayBuffer(wbout.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== wbout.length; ++i) {
        view[i] = wbout.charCodeAt(i) & 0xFF;
        //console.log(view[i]);
      };
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Component_Progress_Client_Level.xlsx');
    }
    else if (value == 'Component Progress - Rollup') {
      let contentData = this.alldup1.nativeElement;
      this.ws = utils.table_to_sheet(contentData);
      let reportContent = this.reportName.nativeElement;
      const ws_name = 'TaskSheet';
      const wb: WorkBook = { SheetNames: [], Sheets: {} };
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = this.ws;
      const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
      const buf = new ArrayBuffer(wbout.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== wbout.length; ++i) {
        view[i] = wbout.charCodeAt(i) & 0xFF;
        //console.log(view[i]);
      };
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Component_Progress_Rollup.xlsx');
    }
    else if (value == 'Educational Gains - Rollup') {
      let contentData = this.allLast1.nativeElement;
      this.ws = utils.table_to_sheet(contentData);
      let reportContent = this.reportName.nativeElement;
      const ws_name = 'TaskSheet';
      const wb: WorkBook = { SheetNames: [], Sheets: {} };
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = this.ws;
      const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
      const buf = new ArrayBuffer(wbout.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== wbout.length; ++i) {
        view[i] = wbout.charCodeAt(i) & 0xFF;
        //console.log(view[i]);
      };
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Educational Gains - Rollup.xlsx');
    }
  }
  //code end
  searchTask(event) {
    this.firstTime = true;
    if( this.validDates() )
    {
      this.inputTasksVO = new TasksVO();
      this.roleId = this.sharedData.get("roles")[0].id;
    //code for enable and disable
   if (this.sharedData.get("roles")[0].id == 5) {
     this.butDisabled = true;
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
        this.inputTasksVO.user = "provider";
        console.log("county id is : " + this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
      }
      this.inputTasksVO.countyArray = this.countyArray;
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
     for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.inputTasksVO.user = "countyWorker";
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.county=this.countyArray[0];
    this.inputTasksVO.provider=null;
    this.inputTasksVO.areaCode=null;
    this.butDisabled = true;
    this.countyDisabled = true;
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.user="areaSupervisor";
    this.inputTasksVO.county="All"
    this.inputTasksVO.provider = null;
     }
    else
    {
     }

      if (this.reportBeginDate != null) {
        let day = this.reportBeginDate.day;
        let month = this.reportBeginDate.month;
        let year = this.reportBeginDate.year;
        if (day < 10 && month < 10) {
          this.reportBeginDate = year + '/0' + month + '/0' + day;
        }
        else if (day < 10) {
          this.reportBeginDate = year + '/' + month + '/0' + day;
        }
        else if (month < 10) {
          this.reportBeginDate = year + '/0' + month + '/' + day;
        }
        else {
          this.reportBeginDate = year + '/' + month + '/' + day;
        }

        console.log(this.reportBeginDate);
      }

      if (this.reportEndDate != null) {
        let day = this.reportEndDate.day;
        let month = this.reportEndDate.month;
        let year = this.reportEndDate.year;
        this.reportEndDate = year + '/' + month + '/' + day;
        if (day < 10 && month < 10) {
          this.reportEndDate = year + '/0' + month + '/0' + day;
        }
        else if (day < 10) {
          this.reportEndDate = year + '/' + month + '/0' + day;
        }
        else if (month < 10) {
          this.reportEndDate = year + '/0' + month + '/' + day;
        }
        else {
          this.reportEndDate = year + '/' + month + '/' + day;
        }
      }

      if (this.report == 'CR') {
        this.inputTasksVO.report = this.report;
        this.inputTasksVO.provider = Object.keys(this.reportProviders).find(key => this.reportProviders[key] === this.provider);
        this.inputTasksVO.county = this.county;
      }
      if (this.report == 'CC') {
        this.inputTasksVO.report = this.report;
        this.inputTasksVO.clientSearch = this.clientSearch;
      }
      if (this.report == 'ER') {
        this.inputTasksVO.report = this.report;
        this.inputTasksVO.provider = this.provider;
        this.inputTasksVO.county = this.county;
      }
    }

    if(this.report=='CR'){
      this.inputTasksVO.report=this.report;
      this.inputTasksVO.areaCode=this.areaCode;
      this.inputTasksVO.provider=Object.keys(this.reportProviders).find(key => this.reportProviders[key] === this.provider);
      this.inputTasksVO.county=this.county;
      this.inputTasksVO.participation = this.reportParticipation;
    }
    if(this.report=='CC'){
      this.inputTasksVO.report=this.report;
      this.inputTasksVO.areaCode=this.areaCode;
      this.inputTasksVO.clientSearch=this.clientSearch;
    }
    if(this.report=='ER'){
      this.inputTasksVO.report=this.report;
      this.inputTasksVO.provider=this.provider;
      this.inputTasksVO.areaCode=this.areaCode;
      this.inputTasksVO.county=this.county;
    }
    this.inputTasksVO.reportBeginDate=this.reportBeginDate;
    this.inputTasksVO.reportEndDate=this.reportEndDate;

    this.loaderFocus = false;
    this.loaderGenerateFocus = true;
    //event.srcElement.blur();
    //event.preventDefault();
    this.load();
    this.loadUserInformation();
    //this.getComponentCountListColumnDefinitions();
    //this.getComponentProgressColumnDefinitions();
    //this.getEducationalGainsColumnDefinitions();
  }


  getSuggestions(event) {
    if (this.clientSearch.length < MIN_CHAR_SEARCH_LENGTH) {
      this.noData = false;
    }

    if (this.clientSearch.length >= MIN_CHAR_SEARCH_LENGTH) {
      //event.srcElement.blur();
      //event.preventDefault();
      this.elasticSearch(this.clientSearch, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        this.suggestions = value;
      });
    } else {
      this.suggestions = [];
    }
  }
  elasticSearch(searchQuery, results) {
    const countiesArr = this.dataService.getSharedDataObject().get("userCounties");
    let providerId = this.dataService.getSharedDataObject().get("providerId");
    let countiesStr = '';

    if (countiesArr !== undefined && countiesArr !== null) {
      for (const c of countiesArr) {
        countiesStr += c.id.serviceCounty + ",";
      }
      countiesStr.substring(0, countiesStr.length - 2);
    }

    searchQuery = searchQuery.replace(new RegExp('/', 'g'), "");

    if (providerId === null || providerId === undefined) providerId = 0;

    if (countiesStr !== undefined && providerId !== undefined) {

      this.http.post(this.ServerConstants.COMMON_SERVER_API_URL + '/search/person/', {text: searchQuery, counties: countiesStr, providerId: providerId}).subscribe(
        (val: any[]) => {
          this.valArray = val;
          if (this.valArray === null || this.valArray === undefined || this.valArray.length === 0) {
            this.noData = true;
          }
          results.next(val);

        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          results.next(null);
        }
      );
    }
  }
  autoCompleteResultClick(result) {
    this.clientSearch = result.firstName + ' ' + result.lastName;
    this.suggestions = [];
    this.elasticSuggestions.next(null);
  }
  validDates() {
    if (this.reportBeginDate !== undefined
      && this.reportBeginDate !== null
      && this.reportEndDate !== undefined
      && this.reportEndDate !== null) {
      const startDt = new Date(this.reportBeginDate.year,
        this.reportBeginDate.month - 1,
        this.reportBeginDate.day);
      const endDt = new Date(this.reportEndDate.year,
        this.reportEndDate.month - 1,
        this.reportEndDate.day)
      const startMonth = this.reportBeginDate.month;
      const endMonth = this.reportEndDate.month;
      console.log("begin month " + startDt);
      if (startDt > endDt) {
        this.errorEndDateField = REPSTDT_GT_REPENDDT;
        return false;
      } else {
        this.errorEndDateField = null;
      }
      const nextYear = new Date(startDt);
      nextYear.setFullYear(nextYear.getFullYear() + 1)
      if(endDt >= nextYear)
      {
        this.errorEndDateField = REPSTDT_INTERVAL_REPENDDT;
        return false;
      }
    } else if(this.report=='CR') {
      return (this.checkBeginDate() && this.checkEndDate());
    }
    return true;
  }

  checkBeginDate() {
    if (this.reportBeginDate == undefined
      || this.reportBeginDate == null) {
        console.log("Missing Begin Date");
      this.errorBeginDateField = "Missing Begin Date";
      return false;
    }
    console.log("No Missing Begin Date");
    this.errorBeginDateField = null;
    return true;
  }

  checkEndDate() {
    if (this.reportEndDate == undefined
      || this.reportEndDate == null) {
      this.errorEndDateField = "Missing End Date";
      return false;
    }
    this.errorEndDateField = null;
    return true;
  }

   setCounty(areaCode)
   {
     this.roleId = this.sharedData.get("roles")[0].id;
    //code for enable and disable
    if (this.sharedData.get("roles")[0].id == 5) {
      this.butDisabled = true;
      console.log("counties : " + this.sharedData.get("userCounties").length);
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
        this.inputTasksVO.user = "provider";
        console.log("county id is : " + this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
      }
      this.inputTasksVO.countyArray = this.countyArray;
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
     for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.inputTasksVO.user = "countyWorker";
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.county=this.countyArray[0];
    this.butDisabled = true;
    this.countyDisabled = true;
    this.inputTasksVO.provider=null;
    this.inputTasksVO.areaCode=null;
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.user="areaSupervisor";
    this.inputTasksVO.county="All"
    this.inputTasksVO.areaCode = null;
    this.inputTasksVO.provider = null;
     }
    else
    {
     }
    //this.inputTasksVO = new TasksVO();
    this.datestring = "Generated on: " + new Date().toLocaleString();
    console.log(this.datestring);
    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.username = this.sharedData.get('username');
    this.inputTasksVO.user = this.sharedData.get('username');
    this.inputTasksVO.areaCode='All';
    this.inputTasksVO.user='hello';
    this.getRefTableData();
    this.loadRefData();

    }

  //ar code end
  constructor(private route: ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private dateUtil: DateUtility,
              private data: ReferenceTableService,
              private commonUtil: CommonUtility,
              private refTableService: ReferenceTableService,
              private notificationService: NotificationsService,
              public dataService: DataService,
              private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    this.route.params.subscribe( params => this.reportSelected = params['report']);
  }

  loadUserInformation() {
    this.http.post<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loaduserdata', null).subscribe(
      data => {
          var role = '';
          if(data.hasOwnProperty('role')) {
              role = data['role'];
          }

              if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
              {  
                  if (data.hasOwnProperty('providers')) {
                      let userProviders = data['providers'];
                      var keys = Object.keys(userProviders);
                      this.reportProviders = [];
                      
                      var pickup = new DropdownValues();
                      pickup.value = undefined;
                      pickup.name = "Pick an option";
                      this.reportProviders.push(pickup);                     
                      
                      var pickupAll = new DropdownValues();
                      pickupAll.value = "All"
                      pickupAll.name = "All";
                      this.reportProviders.push(pickupAll);
                      for (let k of keys) {
                          var dv = new DropdownValues();
                          dv.value = k;
                          dv.name = userProviders[k];
                          this.reportProviders.push(dv);
                      }    
                  }
              } else if(this.sharedData.get("roles")[0].id == 5) {
                if (data.hasOwnProperty('providers')) {
                    let userProviders = data['providers'];
                    var keys = Object.keys(userProviders);
                    this.reportProviders = [];
                    this.reportProviders = Object.values(data['providers']);        
                    this.provider  =  data['providers'][this.sharedData.get("providerId")];
                 }
                 this.providerDisabled = true; 
              } else {
                if (data.hasOwnProperty('providers')) {
                  let userProviders = data['providers'];
                  var keys = Object.keys(userProviders);
                  this.reportProviders = [];
                  
                  var pickup = new DropdownValues();
                  pickup.value = undefined;
                  pickup.name = "Pick an option";
                  this.reportProviders.push(pickup);                     
                  
                  var pickupAll = new DropdownValues();
                  pickupAll.value = "All"
                  pickupAll.name = "All";
                  this.reportProviders.push(pickupAll);
                  for (let k of keys) {
                      var dv = new DropdownValues();
                      dv.value = k;
                      dv.name = userProviders[k];
                      this.reportProviders.push(dv);
                  }    
              }
          }
  
        }, response => {
          console.log('Get call in error', response);
        }, () => {
  
        });
  }
  



  load(){
    var value: any[] = [];
    this.http.post<TasksVO>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loadTask',this.inputTasksVO).subscribe(
      (data:TasksVO ) => {
        // convert date to the proper format for UI
        this.tasksVO=data;
        this.countyList=this.tasksVO.countyList;
        this.columnNameString=this.tasksVO.periodList;
        this.areaCode= this.tasksVO.areaCode;
        this.countyFinalList = this.tasksVO.countyFinalList;
        this.componentCountList = this.tasksVO.componentVOList;
        this.exportTable = [];
        if(this.componentCountList !== null){
          this.componentCountList.forEach((ComponentCount)=>{
            let mm = new Date(ComponentCount.period).getMonth() + 1;
            let dd = new Date(ComponentCount.period).getDate() + 1;
            let yy = new Date(ComponentCount.period).getFullYear();
            this.exportTable.push({"period":mm+'/'+dd+'/'+yy,"yesCount":ComponentCount.yesCount,"noCount":ComponentCount.noCount,"gnCount":ComponentCount.gnCount,
            "ggCount":ComponentCount.ggCount
          })
        })
        }
        this.providerStringList = this.tasksVO.providerStringList;
        this.beginDatePeriod = this.tasksVO.beginDatePeriod;
        this.endDatePeriod = this.tasksVO.endDatePeriod;
        console.log('beginDate is :' + this.beginDatePeriod);
        this.reportStartPeriod = this.beginDatePeriod + " - " + this.endDatePeriod;
        this.assessmentDataVOList = this.tasksVO.assessmentDataVOList;
        //this.providerFinalList = this.tasksVO.providerFinalList;
        this.reportBeginDate = this.tasksVO.reportBeginDate;
        this.reportEndDate = this.tasksVO.reportEndDate;
        this.reportNameOutput = this.tasksVO.reportNameOutput;
        this.clientSearchOutput = this.tasksVO.clientSearchOutput;
        if (this.tasksVO.reportBeginDate != null) {
          this.reportBeginDate = this.dateUtil.convertDateFromServerForreports(this.tasksVO.reportBeginDate);
        }

        if (this.tasksVO.reportEndDate != null) {
          this.reportEndDate = this.dateUtil.convertDateFromServerForreports(this.tasksVO.reportEndDate);
        }
        this.datestring = "Generated on: " + new Date().toLocaleString()
        console.log(this.datestring);
        this.providerOutput = this.tasksVO.providerOutput;
        this.countyOutput = this.tasksVO.countyOutput;
        this.getComponentCountListColumnDefinitions();
        this.getComponentProgressColumnDefinitions();
        this.getEducationalGainsColumnDefinitions();
      }, response => {
        //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
      }, () => {


      });

  }

  //try code

  loadRefData() {
    var value: any[] = [];
    this.http.post<TasksVO>(this.ServerConstants.REPORT_SERVER_API_URL + '/reportTaskSummary/loadTask', this.inputTasksVO).subscribe(
      (data: TasksVO) => {
        // convert date to the proper format for UI
        this.tasksVO = data;
        this.countyList = this.tasksVO.countyList;
        //this.countyList.splice(0, 0, 'Pick an Option', 'All');
        //this.componentCountList = this.tasksVO.componentVOList;
        this.providerStringList = this.tasksVO.providerStringList;
        this.providerStringList.splice(0, 0, 'Pick an Option', 'All');
        this.countyFinalList = this.tasksVO.countyFinalList;
        if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
        {
         this.county=this.tasksVO.county;
        }
        if(this.sharedData.get("roles")[0].id == 5)
        {
         this.provider=this.tasksVO.provider;
        }
        this.providerFinalList = this.tasksVO.providerFinalList;
        this.datestring = "Generated on: " + new Date().toLocaleString();

        this.reportParticipationTypes =[];
        var participationTypesArray = this.tasksVO.participationTypes;
        participationTypesArray.unshift(''); //we can add 'Pick an Option' here if need
        this.reportParticipationTypes = participationTypesArray;
      }, response => {
        //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
      }, () => {


      });

  }
  //try code end

  ngOnInit() {

    this.report = this.reportSelected;
    if(this.reportSelected  !==null && this.reportSelected  !== undefined) {
      this.onLoad(this.reportSelected);
    }
    this.inputTasksVO = new TasksVO();

    this.datestring = "Generated on: " + new Date().toLocaleString();
    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.username = this.sharedData.get('username');
    this.inputTasksVO.user = this.sharedData.get('username');
    this.inputTasksVO.areaCode='All';
    this.inputTasksVO.user='hello';
    if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
      }
      this.inputTasksVO.countyArray=this.countyArray;
    }
    else if(this.sharedData.get("roles")[0].id == 5)
    {
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
      }
      this.inputTasksVO.countyArray=this.countyArray;
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }

    console.log("county " + this.inputTasksVO.countyArray); //use i instead of 0
    this.getRefTableData();
    this.loadRefData();
    this.loadUserInformation();
    //this.getComponentCountListColumnDefinitions();
    //this.getComponentProgressColumnDefinitions();
    //this.getEducationalGainsColumnDefinitions();
  }

  getReportName(report) {
    const index = this.reportNames.findIndex(x => x.value === report);
    if (index !== -1) {
      this.displayReportName = this.reportNames[index].name;
    }
  }
  getRefTableData() {
    this.reportNames = this.refTableService.getValueFromSharedDataMap("REPORT_NAME");
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));

  }

  getComponentCountListColumnDefinitions() {
    this.componentCountListColumnDefs = [
      {
        headerName: 'Month',
        field: 'period'
      },
      {
        headerName: 'Met Plan ?',
        field: 'metPlanCd'
      }
    ];
    this.context = {
      component: this
    }
  }
  getComponentProgressColumnDefinitions() {
    this.componentProgressColumnDefs = [
      {
        headerName: 'Month',
        field: 'period'
      },
      {
        headerName: 'Yes',
        field: 'yesCount'
      },
      {
        headerName: 'No',
        field: 'noCount'
      },
      {
        headerName: 'No-GC Granted',
        field: 'ggCount'
      },
      {
        headerName: 'No-GC Not Granted',
        field: 'gnCount'
      }
    ];
    this.context = {
      component: this
    }
  }

  getEducationalGainsColumnDefinitions() {
    let col = this.columnNameString;
    let row = this.assessmentDataVOList;
    let resultArray = [];
    if (row != null) {
      for (let j = 0; j < row.length; j++) {
        let obj = {};
        for (let i = 0; i < col.length ; i++) {
          obj[col[i]] = row[j].assesmentData[i]
          console.log("grid data is "+row[j].assesmentData[i]);
        }
        resultArray.push(obj);
      }
    }
    this.educationalRowData = resultArray;
    let colDef = [];
    for ( let i = 0; i < col.length; i++) {
      let obj = {};
      obj['headerName'] = col[i];
      obj['field'] = col[i];
      colDef.push(obj);
    }
    this.educationalGainsColumnDefs = colDef;
    this.context = {
      component: this
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }


  onEducationalGridReady(params) {
    this.gridEducationalApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  focusNextGenerate(e) {
    if (e.keyCode === 9 && !e.shiftKey) {
      this.loaderGenerateFocus = false;
      if ( this.componentCountList.length === 0) {
        this.addOnAgGridForAda();
        return;
      } else {
        return;
      }
    }
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  focusAssignedTo(e: KeyboardEvent) {
    this.loaderFocus = true;
  }

  addOnAgGridForAda() {
    // TODO: Check which content is getting displayed
    const element = document.getElementById('contentFirst');
    if (element) {
      if ((element as HTMLDivElement).hasAttribute('tabIndex')) {
        (element as HTMLDivElement).removeAttribute('tabIndex');
      }

      if ((element as HTMLDivElement).hasAttribute('role')) {
        (element as HTMLDivElement).removeAttribute('role');
      }

      if ((element as HTMLDivElement).hasAttribute('aria-labeledby')) {
        (element as HTMLDivElement).removeAttribute('aria-labeledby');
      }

      if (this.tasks.length === 0) { // Empty Ag-Grid
        (element as HTMLDivElement).setAttribute('tabIndex', Number(0).toString());
        (element as HTMLDivElement).setAttribute('role', 'textbox');
        (element as HTMLDivElement).setAttribute('aria-labeledby', 'agGridNotDataFoundDiv');
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    /*if (this.componentCountList.length === 0) {
      return;
    }*/

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    if ( this.selectedValue === 1 || this.selectedValue === 2 ) {
      this.setDisplayedRowAtIndex();
    } else if ( this.selectedValue === 3) {
      this.setEducationalDisplayedRowAtIndex();
    }

  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  setEducationalDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridEducationalApi.getFirstDisplayedRow();
    const rowNode = this.gridEducationalApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridEducationalApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridEducationalApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridEducationalApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if ( this.selectedValue === 1 || this.selectedValue === 2 ) {
        if ( this.gridApi ) {
          this.setDisplayedRowAtIndex();
        }
      } else if ( this.selectedValue === 3) {
        if( this.gridEducationalApi ) {
          this.setEducationalDisplayedRowAtIndex();
        }
      }
    }
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }
}

export class DropdownValues {
  constructor(  
      public name?:string,
      public value?:string,
  ) {}
}


// WEBPACK FOOTER //
// ./src/app/federal-reports/federal-reports.component.ts